import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * A custom renderer for one column's body cells.
 *
 *   <ng-template gridCell="IotStatus" let-device>
 *     <span class="iot-dot" [ngClass]="iotClassFor(device)"></span>
 *   </ng-template>
 *
 * WHY THIS EXISTS: the grid renders `cells: string[]` — precomputed text, which
 * is the whole reason it is fast (this file's neighbours record a real incident
 * from resolving cell values during change detection). Text is the right default
 * and stays the default.
 *
 * But a table is not only text. The devices screen has a status DOT, a tooltip
 * carrying detail the cell cannot show, and a per-row action button. Without a
 * way to project markup those features would have to be dropped or the grid
 * would grow a switch over hard-coded cell "kinds" — a list only the grid could
 * extend, which every new screen would have to edit.
 *
 * A template is projected by the CONSUMER, so the grid never learns about IoT
 * status, unlock actions, or anything else domain-specific. Columns with no
 * template render their precomputed text exactly as before, so the fast path is
 * untouched and opting in is per column.
 */
@Directive({ selector: 'ng-template[gridCell]' })
export class GridCellDirective {
  /** The column id whose cells this template renders. */
  @Input('gridCell') columnId = '';

  constructor(public readonly template: TemplateRef<unknown>) {}
}
